export const getLocalStorageConfigSizesId = (id: string) => `${id}Sizes`;
